export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5665.a8869680.jpg";